import { convertBlobToBase64 } from '@/utils/file';
import { Col, Divider, Form, Row } from 'antd';
import { cloneDeep, sumBy } from 'es-toolkit';
import { useState } from 'react';
import Files from 'react-files';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as FileIcon } from '../../../../../../assets/icons/files-records.svg';
import { FILES_ERROR_CODES } from '../../../../../../contants/common';
import { getOverChargeItemsFromExcelInProgress } from '../../../../../../redux/Claims/OverCharge/OverChargeActions';
import { setAppLoader, setWarningModal } from '../../../../../../redux/common/CommonActions';
import { convertToFloat, formateAmount } from '../../../../../../utilz';
import VerticalLine from '../../../../../components/Bars/VerticalLine';
import Button from '../../../../../components/Buttons/Button';
import SvgConverter from '../../../../../components/Common/SvgConverter';
import FormInput from '../../../../../components/Inputs/FormInput';
import PrimaryLabel from '../../../../../components/Labels/PrimaryLabel';
import Paper from '../../../../../components/Paper/Paper';
import FooterContentCard from '../../../../common/FooterContentCard';
import OverChargeItemsCard from '../../Components/Edit/Components/OverChargeItems/OverChargeItemsCard';
import OverChargeUploadItemsModal from '../../Components/Edit/Components/OverChargeItems/OverChargeUploadItemsModal';

const CreateOverChargeItems = ({ itemList, setItemList }) => {
  const dispatch = useDispatch();
  const [overchargePercentForm] = Form.useForm();
  const [uploadModal, setUploadModal] = useState(false);
  const { itemsFromExcel } = useSelector((state) => state.overChargeClaims);

  const handleAddNew = () => () => {
    let itemListLocal = cloneDeep(itemList);

    itemListLocal = [
      {
        fbOcKey: 0,
        dirtyFlag: 'i',
        itemID: 0,
        proNo: undefined,
        invoiceNumber: undefined,
        packageNumber: undefined,
        shipDate: undefined,
        weight: 0,
        billedAmount: convertToFloat(0),
        paidAmount: convertToFloat(0),
        correctCharges: convertToFloat(0),
        overchargeAmount: 0,
        recoveryAmount: convertToFloat(0),
        isNew: true,
        editMode: true,
      },
      ...itemListLocal,
    ];
    setItemList(itemListLocal);
  };

  const handleUploadFile = async (data) => {
    try {
      if (data.length > 0) {
        const handleSuccess = () => {
          setUploadModal(true);
        };
        dispatch(setAppLoader(true));
        const file = await convertBlobToBase64(data[0]);
        dispatch(
          getOverChargeItemsFromExcelInProgress({
            file: file.split(',')[1],
            fbocKey: 0,
            handleSuccess,
          }),
        );
      }
    } catch {
      dispatch(setAppLoader(false));
      dispatch(
        setWarningModal({
          open: true,
          description: 'Invalid file,  Please verify the selected file.',
        }),
      );
    }
  };

  const handleUploadFileError = (e) => {
    let errorMessage = e.message;
    if (e.code === FILES_ERROR_CODES.INVALID_FILE_TYPE) {
      errorMessage += '. Only .xlsx and .xls files can be uploaded.';
    }
    dispatch(setWarningModal({ open: true, description: errorMessage }));
  };

  const setEditMode = (index, val) => {
    const itemListLocal = cloneDeep(itemList);
    itemListLocal[index].editMode = val;
    setItemList(itemListLocal);
  };

  const handleCancel = (index, isNew) => () => {
    const itemListLocal = cloneDeep(itemList);
    if (isNew) {
      itemListLocal.splice(index, 1);
    } else {
      itemListLocal[index] = {
        ...itemListLocal[index],
        editMode: false,
      };
    }
    setItemList(itemListLocal);
  };

  const handleSubmit = (data, index) => {
    const itemListLocal = cloneDeep(itemList);
    itemListLocal[index] = data;
    itemListLocal[index].editMode = false;
    itemListLocal[index].isNew = false;
    setItemList(itemListLocal);
  };

  const handleDelete = (index) => () => {
    const itemListLocal = cloneDeep(itemList);
    itemListLocal.splice(index, 1);
    setItemList(itemListLocal);
  };
  const overChargePercent = Form.useWatch('overChargePercent', overchargePercentForm);

  const handleOverChargePercentCalculation = () => {
    let itemListLocal = cloneDeep(itemList);
    itemListLocal = itemListLocal.map((row) => ({
      ...row,
      recoveryAmount: ((row.overchargeAmount ? row.overchargeAmount : 0) * overChargePercent) / 100,
    }));
    setItemList(itemListLocal);
  };

  const handleUploadApply = (paramItems) => {
    const items = paramItems.map((row) => {
      const paidAmountL = row.paidAmount ? row.paidAmount : 0;
      const correctChargesL = row.correctCharges ? row.correctCharges : 0;
      let diffAmount = 0;
      diffAmount = paidAmountL - correctChargesL;
      diffAmount = diffAmount >= 0 ? diffAmount : diffAmount * -1;
      return { ...row, overchargeAmount: diffAmount, isNew: false };
    });
    setItemList(items);
    setUploadModal(false);
  };

  return (
    <div>
      <Row className="align-items-center" justify="space-between">
        <Col>
          <PrimaryLabel className="fw-700 f-18">Overcharge Claim Items</PrimaryLabel>
        </Col>
        <Col>
          <Row justify="end" gutter={16} align="middle">
            <Col>
              <Button onClick={handleAddNew()}>Add New Item</Button>
            </Col>
            <Col>
              <Files
                className="files-dropzone"
                onChange={handleUploadFile}
                onError={handleUploadFileError}
                accepts={['.xls', '.xlsx']}
                multiple={false}
                // maxFileSize={10000000}
                minFileSize={0}
                clickable
              >
                <Button>
                  <SvgConverter Icon={FileIcon} color="white" width={16} height={16} className="mr-5" />
                  Upload File
                </Button>
              </Files>
            </Col>
            <Col>
              <Form form={overchargePercentForm}>
                <FormInput name="overChargePercent" inputType="number" editMode margin="m-0" placeholder=" " />
              </Form>
            </Col>
            <Col>
              <Button disabled onClick={handleOverChargePercentCalculation}>
                Apply
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100 " />
      <div className="flex-1 custom-scroll-bar">
        {itemList.map((row, index) => (
          <OverChargeItemsCard
            noteDetails={row}
            key={row.itemID}
            index={index}
            editMode={Boolean(row.editMode)}
            setEditMode={setEditMode}
            handleCancel={handleCancel}
            handleSubmit={handleSubmit}
            handleDelete={handleDelete}
          />
        ))}
      </div>
      <Paper className="background-header px-16 py-5">
        <Row justify="space-around" className="px-10" gutter={10}>
          <Col>
            <FooterContentCard
              reverse
              align="middle"
              count={formateAmount(sumBy(itemList, ({ billedAmount }) => Number(billedAmount)))}
              label="Billed Amount"
              contentClass="text-white f-16 fw-600"
              labelClass="text-light f-14"
            />
          </Col>
          <Col>
            <VerticalLine />
          </Col>
          <Col>
            <FooterContentCard
              reverse
              align="middle"
              count={formateAmount(sumBy(itemList, ({ paidAmount }) => Number(paidAmount)))}
              label="Paid Amount"
              contentClass="text-white f-16 fw-600"
              labelClass="text-light f-14"
            />
          </Col>
          <Col>
            <VerticalLine />
          </Col>
          <Col>
            <FooterContentCard
              reverse
              align="middle"
              count={formateAmount(sumBy(itemList, ({ correctCharges }) => Number(correctCharges)))}
              label="Correct Charges"
              contentClass="text-white f-16 fw-600"
              labelClass="text-light f-14"
            />
          </Col>
          <Col>
            <VerticalLine />
          </Col>
          <Col>
            <FooterContentCard
              reverse
              align="middle"
              count={formateAmount(sumBy(itemList, ({ overchargeAmount }) => Number(overchargeAmount)))}
              label="Overcharge Sum"
              contentClass="text-white f-16 fw-600"
              labelClass="text-light f-14"
            />
          </Col>
          <Col>
            <VerticalLine />
          </Col>
          <Col>
            <FooterContentCard
              reverse
              align="middle"
              count={formateAmount(sumBy(itemList, ({ recoveryAmount }) => Number(recoveryAmount)))}
              label="Recovery Sum"
              contentClass="text-white f-16 fw-600"
              labelClass="text-light f-14"
            />
          </Col>
        </Row>
      </Paper>
      <OverChargeUploadItemsModal
        open={uploadModal}
        setOpen={setUploadModal}
        items={itemsFromExcel?.data ? itemsFromExcel?.data : []}
        handleApply={handleUploadApply}
      />
    </div>
  );
};

export default CreateOverChargeItems;
